import { useCallback, useEffect, useState } from "react";
import {
  getAuth,
  GoogleAuthProvider,
  onAuthStateChanged,
  signInWithPopup,
  signInWithRedirect,
  signOut,
} from "firebase/auth";
import { app } from "../helpers/FirebaseConfig";

const provider = new GoogleAuthProvider();
provider.setCustomParameters({
  prompt: "select_account",
});

const auth = getAuth(app);

export const useGoogleAuth = () => {
  const [user, setUser] = useState(null);
  const [initializing, setInitializing] = useState(true);
  const [error, setError] = useState(null);

  // useEffect(() => {
  //   const unsubscribe = onAuthStateChanged(
  //     auth,
  //     (firebaseUser) => {
  //       console.log("Auth state changed, user:", firebaseUser); 
  //       setUser(firebaseUser);
  //       setInitializing(false);
  //     },
  //     (err) => {
  //       console.error("Auth listener error", err);
  //       setError(err);
  //       setInitializing(false);
  //     }
  //   );

  //   return () => unsubscribe();
  // }, []);

  const login = useCallback(async (options = {}) => {
    const { forceRedirect = false } = options;
    setError(null);
    try {
      const isSmallScreen =
        typeof window !== "undefined" ? window.innerWidth < 640 : false;
      if (forceRedirect || isSmallScreen) {
      const result =  await signInWithRedirect(auth, provider);
            setUser(result.user);
          console.log("Google login successful:", result);

      } else {
       const result = await signInWithPopup(auth, provider);
       console.log("Google login successful:", result);
       setUser(result.user);
      }
              setInitializing(false);

    } catch (err) {
      console.error("Google login failed", err);
      setError(err);
      throw err;
    }
  }, []);

  const logout = useCallback(async () => {
    setError(null);
    try {
      await signOut(auth);
      setUser(null);
    } catch (err) {
      console.error("Logout failed", err);
      setError(err);
    }
  }, []);

  return {
    user,
    initializing,
    error,
    login,
    logout,
  };
};
